import React, { useRef } from "react";
import { motion, useInView } from "motion/react";
import { staggerContainer } from "./AnimationVariants";
import { HeroContent } from "./HeroContent";
import { PartnerStrip } from "./PartnerStrip";
import { ScrollCue } from "./ScrollCue";

export function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(heroRef, { once: true, margin: "-50px" });

  return (
    <section
      ref={heroRef}
      className="relative w-full flex flex-col justify-center py-6 lg:py-0 lg:pt-16 lg:min-h-[calc(100svh-3.5rem)]"
    >
      <motion.div
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={staggerContainer}
        className="mx-auto max-w-[1400px] w-[calc(100%-2rem)] md:w-[calc(100%-240px)] grid grid-cols-1 gap-6 items-center"
      >
        <HeroContent />
      </motion.div>
      <PartnerStrip />
      <ScrollCue />
    </section>
  );
}
